import React from 'react';

import './index.css';
import FormIdea from '../../components/formIdea';
import WorkPortfolio from '../../components/workPortfolio';
import Presentation from '../../components/presentation';

class Portfolio extends React.Component {
  navigation = React.createRef();
  state = {
    filter: 'all'
  }

  handleWorkChange = (tab) => {
    this.setState({ filter: tab });
  }

  handleScroll = () => {
    let scroll = window.pageYOffset || document.documentElement.scrollTop;
    const navigation = this.navigation.current;
    if (window.innerWidth >= 1201) {
      if (scroll >= 590) {
        navigation.classList.add('port__nav__fixed');
      }
      else if (scroll <= 591) {
        navigation.classList.remove("port__nav__fixed");
      }
    }
    else if (window.innerWidth >= 1001 && window.innerWidth <= 1200) {
      if (scroll >= 382) {
        navigation.classList.add('port__nav__fixed');
      }
      else if (scroll <= 381) {
        navigation.classList.remove("port__nav__fixed");
      }
    }
    else if (window.innerWidth <= 1000 && window.innerWidth >= 769) {
      if (scroll >= 321) {
        navigation.classList.add('port__nav__fixed');
      }
      else if (scroll <= 320) {
        navigation.classList.remove("port__nav__fixed");
      }
    }
    else if (window.innerWidth <= 768 && window.innerWidth >= 541) {
      if (scroll >= 318) {
        navigation.classList.add('port__nav__fixed');
      }
      else if (scroll <= 319) {
        navigation.classList.remove("port__nav__fixed");
      }
    }
    else if (window.innerWidth <= 540 && window.innerWidth >= 415) {
      if (scroll >= 390) {
        navigation.classList.add('port__nav__fixed');
      }
      else if (scroll <= 389) {
        navigation.classList.remove("port__nav__fixed");
      }
    }
    else if (window.innerWidth <= 540) {
      if (scroll >= 285) {
        navigation.classList.add('port__nav__fixed');
      }
      else if (scroll <= 286) {
        navigation.classList.remove("port__nav__fixed");
      }
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    return (
      <div className="port page">
        {
          typeof this.props.match.params.current !== "undefined" && <Presentation current={this.props.match.params.current} history={this.props.history} />
        }
        <div className="port__img">
          <div className="port__img__text">
            <h1>{localStorage.getItem('lang') == 'ru'? 'Портфолио':'Portfolio'}</h1>
            <span className="subtitle">{localStorage.getItem('lang') == 'ru'? 'Мы реализовываем сложнейшие проекты на высоком уровне':'We carry out complex projects at a high level.'}</span>
          </div>
          <div ref={this.navigation} className={["port__nav",].join('')}>
            <div className="port__nav__scroller">
              <nav className="port__nav__container">
                <div className={["port__link", (this.state.filter === 'all') ? ' port__link--active' : ''].join('')} onClick={() => this.handleWorkChange('all')}
                >{localStorage.getItem('lang') == 'ru'? 'Все проекты':'All projects'}</div>
                <div className={["port__link", (this.state.filter === 'Mobile app') ? ' port__link--active' : ''].join('')} onClick={() => this.handleWorkChange('Mobile app')}
                >Mobile</div>
                <div className={["port__link", (this.state.filter === 'Web site') ? ' port__link--active' : ''].join('')} onClick={() => this.handleWorkChange('Web site')}
                >Web</div>
                <div className={["port__link", (this.state.filter === 'Promo') ? ' port__link--active' : ''].join('')} onClick={() => this.handleWorkChange('Promo')}
                >{localStorage.getItem('lang') == 'ru'? 'Промо':'Promo'}</div>
                <div className={["port__link", (this.state.filter === 'CRM system') ? ' port__link--active' : ''].join('')} onClick={() => this.handleWorkChange('CRM system')}
                >CRM</div>
              </nav>
            </div>
          </div>
        </div>
        <div className="port__works">
          <WorkPortfolio type={this.state.filter} />
        </div>
        <FormIdea theme="dark" />
      </div>

    )
  }
}

export default Portfolio;



// WEBPACK FOOTER //
// ./src/pages/portfolio/index.jsx